






















import Vue from 'vue'
import { TextWithStatusElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'TextWithStatus',
  props: {
    templateItemData: {
      type: Object as () => TextWithStatusElInterface,
      required: true
    }
  },
  computed: {
    separator (): string {
      if (!Object.prototype.hasOwnProperty.call(this.$props.templateItemData, 'separator')) {
        return ''
      }
      return `height: 1px; background-color: ${this.$props.templateItemData.separator};`
    }
  }
})
